import { AxiosService } from '../../../axios/axios.service';
import {
  tFunnel,
  tPipeResponse,
  tWorkspaceFunnel,
} from '../../Pipe/Pipe.types';
import {
  tIndustryTypesResponse,
  tSaveOnboardingFunnelRequest,
  tSaveOnboardingInfoRequest,
} from './CreateWorkspace.types';

export const CreateWorkspaceService = {
  getIndustryTypes: async function (): Promise<tIndustryTypesResponse> {
    try {
      const response = await AxiosService.get<tIndustryTypesResponse>(
        '/auth/industry-types',
      );

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  saveOnboardingInfo: async function (
    workspaceId: string,
    userId: string,
    request: tSaveOnboardingInfoRequest,
  ): Promise<void> {
    try {
      const options = {
        headers: {
          'Auth-id': userId,
        },
        isLegacy: true,
      };

      await AxiosService.post<tSaveOnboardingInfoRequest, unknown>(
        `workspaces/ws/${workspaceId}/onboarding-form`,
        request,
        options,
      );

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  getWorkspaceFunnels: async function (
    workspaceUuid: string,
  ): Promise<tPipeResponse<{ pipes: tWorkspaceFunnel[] }>> {
    try {
      const response = await AxiosService.get<
        tPipeResponse<{ pipes: tWorkspaceFunnel[] }>
      >(`workspace/${workspaceUuid}/pipes`);

      if (response.data.pipes === null)
        throw new Error('No se encontraron embudos para este workspace');

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  getFunnelInfo: async function (
    workspaceId: string,
    funnelUuid: string,
  ): Promise<tPipeResponse<tFunnel>> {
    try {
      const response = await AxiosService.get<tPipeResponse<tFunnel>>(
        `/workspace/${workspaceId}/pipe/${funnelUuid}`,
      );

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  saveOnboardingFunnel: async function (
    workspaceId: string,
    request: tSaveOnboardingFunnelRequest,
  ): Promise<tPipeResponse<unknown>> {
    try {
      const response = await AxiosService.post<
        tSaveOnboardingFunnelRequest,
        tPipeResponse<unknown>
      >(`/workspace/${workspaceId}/onboarding/pipe`, request, { isBFFService: true });

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
